'use client';

import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useTracking } from '@packages/tracking/src/hooks/useTracking/useTracking';
import type { GTMEventGlycerinDisplayCategory } from '@packages/tracking/src/types/events';
import { useEffect } from 'react';

export const CmsContentTracking = ({ field_pagegroup }: { field_pagegroup: string }) => {
  const dispatchGTMEvent = useTracking();
  const {
    tracking: { categoryIdHomepage },
  } = useConfig();

  useEffect(() => {
    // dispatch information to fire landmark: 'http://localhost/servlet/11?clientId=1009&landmark=page&ssid=1009xxxxxxxxx&pc=storefront&pc2=homepage'
    dispatchGTMEvent({
      event: 'ga_event',
      eventValue: field_pagegroup,
      eventAction: 'view',
      eventCategory: field_pagegroup,
      eventLabel: 'inspire',
    });

    // only fire DisplayCategory event if it's the homepage
    if (field_pagegroup === 'KS_Homepage') {
      dispatchGTMEvent<GTMEventGlycerinDisplayCategory>({
        event: 'DisplayCategory',
        DisplayCategoryData: {
          categoryId: categoryIdHomepage,
        },
      });
    }
  }, [dispatchGTMEvent, field_pagegroup, categoryIdHomepage]);

  return null;
};
